module.exports = __webpack_public_path__ + "static/defaultCover-cb3e1b8f028234ea5bbda378bc3294b4.jpg";